export const PatternWarningLevels = {
    NEUTRAL: 0,
    HIGH: 1,
    MODERATE: 2,
    POSITIVE: 3,
}

export const getPatternWarningLevelName = level => {
    switch (level) {
        case PatternWarningLevels.NEUTRAL:
            return 'Neutral'
        case PatternWarningLevels.HIGH:
            return 'High'
        case PatternWarningLevels.MODERATE:
            return 'Moderate'
        case PatternWarningLevels.POSITIVE:
            return 'Positive'
        default:
            return 'Unknown pattern warning level'
    }
}

export const getPatternWarningLevelDescription = level => {
    switch (level) {
        case PatternWarningLevels.NEUTRAL:
            return 'Informational feedback - neutral observation about your code'
        case PatternWarningLevels.HIGH:
            return 'High priority issue in your code that should be addressed'
        case PatternWarningLevels.MODERATE:
            return 'Moderate concern or area for improvement in your code'
        case PatternWarningLevels.POSITIVE:
            return 'Good practice or correct implementation observed in your code'
        default:
            return 'Unknown pattern warning level'
    }
}

export const getPatternWarningLevelColor = level => {
    switch (level) {
        case PatternWarningLevels.NEUTRAL:
            return '#3A5683'
        case PatternWarningLevels.HIGH:
            return '#E7086D'
        case PatternWarningLevels.MODERATE:
            return '#FA7921'
        case PatternWarningLevels.POSITIVE:
            return '#04F06A'
        default:
            return '#000000'
    }
}
